import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ACTION_TYPE, GAME_STATE} from "utils";
import View from "./View";
import {sendGameMessage, setGameState} from "store/actions/game";

export default function Container() {
  const dispatch = useDispatch();
  const game = useSelector(state => state.game);
  const {messageFromGame} = useSelector(state => state.game);
  const [textSet, setTextSet] = useState(null);
  const [isDialogueOpen, setIsDialogueOpen] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [currentText, setCurrentText] = useState(null);
  const [npcName, setNpcName] = useState(null);
  const [previousAction, setPreviousAction] = useState(null);

  const onClickDialogue = () => {
    if (textSet.length === currentIdx + 1) {
      setCurrentIdx(0);
      setIsDialogueOpen(false);
      dispatch(
        sendGameMessage({
          type: ACTION_TYPE.SEND_GAME_MESSAGE,
          message: {
            type: "CHAT_END",
            name: npcName,
            previousAction: previousAction,
          },
        }),
        dispatch(setGameState(GAME_STATE.PLAYING)),
      );
    } else {
      setCurrentIdx(currentIdx + 1);
    }
  };

  useEffect(() => {
    if (messageFromGame && messageFromGame.textSet) {
      setIsDialogueOpen(true);
      setTextSet(messageFromGame.textSet);
      setNpcName(messageFromGame.name);
      setPreviousAction(messageFromGame.previousAction);
    }
  }, [messageFromGame]);

  useEffect(() => {
    if (textSet) {
      setCurrentText(textSet[currentIdx]);
    }
  }, [currentIdx, textSet]);

  return (
    <View
      onClickDialogue={onClickDialogue}
      isDialogueOpen={isDialogueOpen}
      npcName={npcName}
      currentText={currentText}
    />
  );
}
